"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const SvgTransaction = (props, ref) => (React.createElement("svg", { ...props, xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", viewBox: "0 0 1024 1024", fill: "currentColor", className: `Icon ${props?.className || ""}`, ref: ref },
    React.createElement("path", { d: "M921.6 102.4H307.2c-56.5.1-102.3 45.9-102.4 102.4v31.5C98.1 265.1 0 354.6 0 539.3v136.5c0 135.6 110.2 245.8 245.8 245.8H553c56.6 0 102.4-45.9 102.4-102.4 0-6.9-.7-13.7-2.1-20.5h63.5c56.6 0 102.4-45.9 102.4-102.4 0-6.9-.7-13.7-2.1-20.5h104.5c56.5-.1 102.3-45.9 102.4-102.4V204.8c-.1-56.5-45.9-102.3-102.4-102.4M286.7 204.8c0-11.3 9.2-20.5 20.5-20.5h614.4c11.3 0 20.5 9.2 20.5 20.5v61.4H508.7c-22-25.1-57.3-41-99.1-41H286.7zm450.6 491.5c0 11.3-9.2 20.5-20.5 20.5H450.6c-22.6-1.1-41.9 16.3-43 38.9s16.3 41.9 38.9 43c1.3.1 2.7.1 4 0H553c11.3 0 20.5 9.2 20.5 20.5s-9.2 20.5-20.5 20.5H245.8C155.4 839.7 82 766.2 82 675.9V539.3c0-215.4 156.8-232.1 204.8-232.1h122.8c17.2 0 41 7.1 41 20.5v20.5c0 14.1-24 20.5-41 20.5h-81.9c-18.3 0-34.4 12.1-39.4 29.7C277 438 240.8 512 204.8 512c-22.6 1.1-40 20.4-38.9 43 1 21.1 17.9 37.9 38.9 38.9l2-.3c9.7 47.8 51.6 82.2 100.4 82.2h409.6c11.3 0 20.5 9.2 20.5 20.5m184.3-102.4H307.2c-11.3 0-20.5-9.2-20.5-20.5v-13.3c35.4-31.7 58.2-78.7 70.2-109.6h52.7c71.2 0 122.9-43.1 122.9-102.4h409.6v225.3c0 11.3-9.2 20.5-20.5 20.5" })));
const ForwardRef = (0, react_1.forwardRef)(SvgTransaction);
exports.default = ForwardRef;
